import { Injectable } from '@angular/core';
import { BaseUserDTO } from '@sb-tools/typescript/models/dto/base-user.dto';
import { SimpleCommunityWithOpenTicketsCount } from '@sb-tools/typescript/models/simple-community-with-open-tickets-count.model';

@Injectable({
    providedIn: 'root',
})
export class OutlookUserService {
    communities: SimpleCommunityWithOpenTicketsCount[] = [];
    isLoggedIn: boolean;
    user: BaseUserDTO;
}
